import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=00ed1c3c&scoped=true&"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js&"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed1c3c",
  null
  
)

export default component.exports